import {VueComponent} from '@tfx/common/initializers'
VueComponent('issue-form', () => import(/* webpackChunkName: "issue-form" */'./form'))
VueComponent('issue-button', () => import(/* webpackChunkName: "issue-form" */'./issue-button'))
